
    import {
        computed,
        defineComponent,
        unref,
    } from 'vue';
    import { useState } from 'vuex-composition-helpers';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import CheckBoxInputList from '@fr/vue/components/inputs/CheckBoxInputList.vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import { IMapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
    import asyncSvGLoader from '@ve/services/asyncSvgLoader';
    import IconBase from '@ve/services/IconBase.vue';
    import useOperatorsFilterHotel from '../common/useOperatorsFilterHotel';
    import iconArrow from './img/arrow.svg';

    const filtersMappingStoreName = 'mapForFilters';
    export default defineComponent({
        name: 'operators-filter-hotel',
        components: {
            Dropdown,
            CheckBoxInputList,
            CheckBoxInput,
            IconBase,
            IconArrow: asyncSvGLoader(iconArrow),
        },
        setup(props, { emit }) {
            const {
                operators,
            } = useState<IMapForFiltersState>(filtersMappingStoreName, ['operators']);

            const selectedOperators = computed({
                get: () => unref(operators),
                set: (value) => {
                    emit('operators-filter-changed', value);
                },
            });

            return {
                ...useOperatorsFilterHotel({ selectedOperators }),
                selectedOperators,
            };
        },
    });
